// extracted by mini-css-extract-plugin
export default {"dashboardElement":"dashboard-element_dashboardElement__U7XS2"};